(function () {
  // --- Terms checkbox gate: disables the real Add to Cart button until
  // the checkbox is checked. Only touches the button if it wasn't already
  // disabled for another reason (e.g. sold out).
  function syncTermsGate(gate) {
    var checkbox = gate.querySelector('[data-jv-terms-checkbox]');
    var targetId = gate.getAttribute('data-target-button');
    var button = targetId && document.getElementById(targetId);
    if (!checkbox || !button) return;

    if (button.disabled && button.dataset.jvTermsLocked !== 'true') {
      // Disabled for a real reason (sold out / unavailable) -- leave it.
      return;
    }

    if (checkbox.checked) {
      if (button.dataset.jvTermsLocked === 'true') {
        button.disabled = false;
        delete button.dataset.jvTermsLocked;
      }
    } else {
      button.disabled = true;
      button.dataset.jvTermsLocked = 'true';
    }
  }

  function initTermsGates(root) {
    (root || document).querySelectorAll('[data-jv-terms-gate]').forEach(syncTermsGate);
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches('[data-jv-terms-checkbox]')) {
      var gate = event.target.closest('[data-jv-terms-gate]');
      if (gate) syncTermsGate(gate);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    initTermsGates(document);

    // Dawn re-renders the buy buttons on variant change (AJAX section
    // fetch). Re-apply the gate whenever that happens.
    var observer = new MutationObserver(function () {
      initTermsGates(document);
    });
    document.querySelectorAll('product-info').forEach(function (el) {
      observer.observe(el, { childList: true, subtree: true });
    });
  });

  // --- Third-party widgets that inject themselves onto every page via
  // their own remote-controlled placement rules, independent of any theme
  // block: Essential Estimated (delivery widget) and Ultimate Trust Badge
  // (a separate embed from the same vendor as the footer's trust badges,
  // sharing the <trust-badges> tag name -- we only remove instances
  // OUTSIDE the footer, since the footer's own block should stay).
  // A single removal pass isn't reliable: these load as async/remote
  // scripts that can render after our first pass, so we combine a
  // MutationObserver with a short polling window to catch late inserts.
  function removeStrayWidgets() {
    document.querySelectorAll('essential-estimated-delivery-app-embed').forEach(function (el) {
      el.remove();
    });
    document.querySelectorAll('trust-badges').forEach(function (el) {
      if (!el.closest('footer')) {
        el.remove();
      }
    });
    // The <trust-badges> tag is only a trigger -- the actual widget is a
    // separately-created div (id="ultimateTrustBadgeswidgetDiv") injected
    // near the buy buttons by the app's own remote placement logic.
    document.querySelectorAll('#ultimateTrustBadgeswidgetDiv, .ultimateTrustBadgesInnerContainer').forEach(
      function (el) {
        if (!el.closest('footer')) {
          el.remove();
        }
      }
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    removeStrayWidgets();

    var widgetObserver = new MutationObserver(function () {
      removeStrayWidgets();
    });
    widgetObserver.observe(document.body, { childList: true, subtree: true });

    // Belt-and-suspenders: these third-party widgets load remote scripts
    // that can render well after DOMContentLoaded, so keep polling for the
    // first 15 seconds in case a mutation slips past the observer.
    var pollCount = 0;
    var pollInterval = setInterval(function () {
      removeStrayWidgets();
      pollCount += 1;
      if (pollCount >= 30) clearInterval(pollInterval);
    }, 500);
  });

  // --- Shared modal shell (used by Ask an Expert) ---
  // Move modals to be direct children of <body> so position:fixed always
  // centers against the true viewport, regardless of any positioned/
  // stacking-context ancestor in the product form where they're defined.
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.jv-modal-overlay').forEach(function (modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-jv-modal-open]');
    if (trigger) {
      var modal = document.getElementById(trigger.getAttribute('data-jv-modal-open'));
      if (modal) {
        modal.hidden = false;
        document.body.classList.add('overflow-hidden');
      }
      return;
    }

    var closer = event.target.closest('[data-jv-modal-close]');
    if (closer) {
      var modalToClose = closer.closest('.jv-modal-overlay');
      if (modalToClose) {
        modalToClose.hidden = true;
        document.body.classList.remove('overflow-hidden');
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.jv-modal-overlay:not([hidden])').forEach(function (modal) {
      modal.hidden = true;
      document.body.classList.remove('overflow-hidden');
    });
  });
})();
